// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2tQUE","row":"Node_row__12UPX","label":"Node_label__14Lxr","footer":"Node_footer__3GYfR"};